import { UserRoleEnum } from "@nlc/shared-types";

type ResolveCreatePasswordRedirectInput = {
  isPasswordReset: boolean;
  planName: null | string;
  roleId?: UserRoleEnum;
};

export type CreatePasswordRedirect =
  | {
      search: {
        billingCycle?: string;
        currency?: string;
        origin: string;
        planName?: string;
        price?: string;
      };
      to: "/subscription-success";
    }
  | { to: "/" };

export function resolveCreatePasswordRedirect({
  isPasswordReset,
  planName,
  roleId,
}: ResolveCreatePasswordRedirectInput): CreatePasswordRedirect {
  if (isPasswordReset || roleId !== UserRoleEnum.Owner) {
    return { to: "/" };
  }

  if (planName?.toLowerCase().includes("first draft")) {
    return { to: "/" };
  }

  return {
    search: {
      origin: "direct-purchase",
      planName: planName ?? undefined,
    },
    to: "/subscription-success",
  };
}
